import { 
    DELETE_CHECKLIST_COMPONENT_FAIL, 
    DELETE_CHECKLIST_COMPONENT_LOADING, 
    DELETE_CHECKLIST_COMPONENT_SUCCESS, 
    EDIT_CHECKLIST_COMPONENT_FAIL, 
    EDIT_CHECKLIST_COMPONENT_LOADING,
    EDIT_CHECKLIST_COMPONENT_SUCCESS} from "../Components/Constants/ActionTypes";


const ChecklistManager = (state,{type,payload})=>{
    switch (type) {
        case DELETE_CHECKLIST_COMPONENT_LOADING:
            return{
                ...state,
                deleteChecklistItem:{
                ...state.deleteChecklistItem,
                loading:true
              }
            };
        case DELETE_CHECKLIST_COMPONENT_SUCCESS:
            return {
                ...state,
                deleteChecklistItem:{
                    ...state.deleteChecklistItem,
                    loading:false,
                    data:payload,
                }
            };
        case DELETE_CHECKLIST_COMPONENT_FAIL:
            return{
                ...state,
                deleteChecklistItem:{
                    ...state.deleteChecklistItem,
                    loading:false,
                    error:payload,
                }
            };
        case EDIT_CHECKLIST_COMPONENT_LOADING:
            return{
                ...state,
                editChecklistItem:{
                ...state.editChecklistItem,
                loading:true
                }
            };
        case EDIT_CHECKLIST_COMPONENT_SUCCESS:
            return {
                ...state,
                editChecklistItem:{
                    ...state.editChecklistItem,
                    loading:false,
                    data:payload,
                }
            };
        case EDIT_CHECKLIST_COMPONENT_FAIL:
            return{
                ...state,
                editChecklistItem:{
                    ...state.editChecklistItem,
                    loading:false,
                    error:payload,
                }
            };
    }
}

export default ChecklistManager;